module.exports = __webpack_public_path__ + "e60de66385b16009fcb5dfa598e13a50.svg";